import { render, staticRenderFns } from "./BulkSelectLocalDelivery.vue?vue&type=template&id=1a24b4a8&scoped=true&lang=pug&"
import script from "./BulkSelectLocalDelivery.vue?vue&type=script&lang=js&"
export * from "./BulkSelectLocalDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a24b4a8",
  null
  
)

/* custom blocks */
import block0 from "./BulkSelectLocalDelivery.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRadio,VRadioGroup,VRow})
